"use client";

import { Play } from "lucide-react";
import Link from "next/link";

// Shared VideoCard component - can be used for both homepage and detail pages
const VideoCard = ({ video, onClick, showLink = true }) => {
    // If onClick is provided, use it (for modal/interactive behavior)
    // If showLink is true and no onClick, use Link for navigation
    // Otherwise just render the card without interaction
    
    const cardContent = (
        <div className="group cursor-pointer overflow-hidden transition-all duration-200 hover:opacity-90 relative w-full">
            {/* Video Thumbnail - YouTube 16:9 */}
            <div 
                className="relative w-full rounded-lg overflow-hidden bg-gray-100"
                style={{
                    aspectRatio: '16/9'
                }}
            >
            {video.featuredImage && (
                <img
                    src={video.featuredImage}
                    alt={video.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                        e.target.style.display = "none";
                    }}
                />
            )}

            {/* Play button overlay - Always visible */}
            <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-black/70 rounded-full p-2 shadow-lg">
                    <Play className="w-4 h-4 text-white ml-0.5" fill="currentColor" />
                </div>
            </div>
            </div>
            
            {/* Video Title - YouTube Style */}
            <div className="mt-2 px-1">
                <h3 className="text-sm font-medium line-clamp-2 text-gray-900">
                    {video.title}
                </h3>
            </div>
        </div>
    );

    // If onClick is provided, wrap with div and use onClick
    if (onClick) {
        return (
            <div onClick={onClick}>
                {cardContent}
            </div>
        );
    }

    // If showLink and video has slug, wrap with Link
    if (showLink && video.slug) {
        return (
            <Link href={`/video/${video.slug}`}>
                {cardContent}
            </Link>
        );
    }

    // Just return the card content
    return cardContent;
};

export default VideoCard;